// extracted by mini-css-extract-plugin
export default {"badge":"MicrositePlacementBadge_badge__xtAoG"};